import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import * as commonUtil from 'assets/js/commonUtil';

interface ParentProps  {
  id: string;
  url: string; 
  text: string;
  on: boolean;
  col: number;
}
const pageTabListProp: ParentProps[] = [
  { id: "tab01", url: "", text: "", on: true, col:0 },
  { id: "tab02", url: "", text: "", on: false, col:0 },
  { id: "tab03", url: "", text: "", on: false, col:0 },
  { id: "tab04", url: "", text: "", on: false, col:0},  
];
const PageTab = ({ props }: { props: ParentProps[] }) => {  

  const { pathname } = useLocation();
  
  //commonUtil.setBodyScroll();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
    <div className="page-tab-section">
      <div className={`page-tab ${props[0].col === 3 ? "col3" : ""} ${props[0].col === 2 ? "col2" : ""} ${props[0].col === 1 ? "col1" : ""}`}>
        {props.map((item, idx) => (
          <div className={`tab ${item.on ? "on" : ""}`} key={idx} onClick={() => commonUtil.goToLocation(item.url)}>{item.text}</div>
        ))}
      </div>
    </div>
    </>
  );
}
export default PageTab;
